import React from 'react'
import Select from 'react-select'
import { styled, context, Label } from '@tools/wr-catalog-base'

const DropdownContainer = styled.div`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : '300px')};

  .categories__option {
    padding: 15px 12px;
    cursor: pointer;
  }

  .categories__control,
  .categories__control:hover,
  .categories__control--is-focused {
    border-color: ${({ theme }) => theme.palette.muted};
    border-width: 1px;
    box-shadow: none;
  }
`

const DropdownInput = ({
  fullWidth,
  large,
  label,
  options,
  onChange,
  value,
  isSearchable,
  isMulti,
  placeholder = 'Select an option',
  theme: catalogTheme,
  closeMenuOnSelect,
  hideSelectedOptions,
  primaryColor: color,
  menuIsOpen,
  getSelectRef,
  className,
  classNamePrefix,
  onMenuClose,
  onMenuOpen,
  hideLabel = false,
  components = {},
}) => {
  const primaryColor = color || context.theme.palette.primary

  return (
    <DropdownContainer large={large} fullWidth={fullWidth} className="dropdown-input">
      <label>
        {label && !hideLabel && <Label>{label}</Label>}

        <Select
          options={options}
          onChange={onChange}
          value={value}
          placeholder={placeholder}
          isSearchable={isSearchable}
          isMulti={isMulti}
          menuIsOpen={menuIsOpen}
          components={components}
          ref={getSelectRef}
          onMenuClose={onMenuClose}
          onMenuOpen={onMenuOpen}
          closeMenuOnSelect={closeMenuOnSelect}
          openMenuOnFocus
          hideSelectedOptions={hideSelectedOptions}
          className={className}
          classNamePrefix={classNamePrefix}
          theme={(theme) => ({
            ...theme,
            borderRadius: `${context.theme.components.dropdownInput.borderRadius}`,
            colors: {
              ...theme.colors,
              primary: `${primaryColor}`,
            },
            spacing: {
              ...theme.spacing,
              controlHeight: `${large}` ? 45 : theme.spacing.controlHeight,
            },
          })}
        />
      </label>
    </DropdownContainer>
  )
}

export default DropdownInput
